import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICurrentUser } from '../../Api/Interface/api.interface';

export interface AuthState {
    isAuthorized: boolean;
    currentUser: ICurrentUser | null;
}

const USER_CACHE_KEY = 'current_user';

const hydrateUser = (): ICurrentUser | null => {
  try {
    const raw = localStorage.getItem(USER_CACHE_KEY);
    return raw ? (JSON.parse(raw) as ICurrentUser) : null;
  } catch {
    return null;
  }
};

const initialState: AuthState = {
  isAuthorized: !!localStorage.getItem('token'),
  currentUser: hydrateUser(),
};

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setEnableAuth: (state) => {
      state.isAuthorized = true;
    },
    setDisableAuth: (state) => {
      state.isAuthorized = false;
      state.currentUser = null;
      localStorage.removeItem(USER_CACHE_KEY);
    },
    setCurrentUser: (state, action: PayloadAction<ICurrentUser | null>) => {
      state.currentUser = action.payload;
      if (action.payload) {
        localStorage.setItem(USER_CACHE_KEY, JSON.stringify(action.payload));
      } else {
        localStorage.removeItem(USER_CACHE_KEY);
      }
    },
  },
});

export const {
  setEnableAuth,
  setDisableAuth,
  setCurrentUser,
} = auth.actions;

export const AuthReducer = auth.reducer;

export { initialState as AuthInitialState };
